module.exports = __webpack_public_path__ + "media/images/question-mark-icon-76cf9942e0b2d6e9a978371f08ef9812.svg";